// extracted by mini-css-extract-plugin
export default {"main":"ClosableBox_main__9ItUG","nameContainer":"ClosableBox_nameContainer__Cuo5+","name":"ClosableBox_name__qw61x","icon":"ClosableBox_icon__Zi7Gq"};